var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Container, List, ListItemAvatar } from '@mui/material';
import { useChainSelect } from '../../components/ChainSelect';
import { useTokenSelect } from '../../components/TokenList';
import { useNavigateBack } from '../../hooks';
import { ListItemButton, ListItemText } from './SelectChainPage.style';
export const SelectChainPage = ({ formType, selectNativeToken, }) => {
    const { navigateBack } = useNavigateBack();
    const { chains, setCurrentChain } = useChainSelect(formType);
    const selectToken = useTokenSelect(formType, navigateBack);
    const handleClick = (chain) => __awaiter(void 0, void 0, void 0, function* () {
        if (selectNativeToken) {
            selectToken(chain.nativeToken.address, chain.id);
        }
        else {
            setCurrentChain(chain.id);
            navigateBack();
        }
    });
    return (_jsx(Container, Object.assign({ disableGutters: true }, { children: _jsx(List, Object.assign({ sx: {
                paddingLeft: 1.5,
                paddingRight: 1.5,
            } }, { children: chains === null || chains === void 0 ? void 0 : chains.map((chain) => (_jsxs(ListItemButton, Object.assign({ onClick: () => handleClick(chain), disableRipple: true }, { children: [_jsx(ListItemAvatar, { children: _jsx(Avatar, Object.assign({ src: chain.logoURI, alt: chain.name }, { children: chain.name[0] })) }), _jsx(ListItemText, { primary: chain.name })] }), chain.id))) })) })));
};
